<template>
  <div>
    <div class="inquiryButton">
      <!-- <div style="width:40px;height:38px;" class="box-shadow shoucang" id="collecplan" v-show="!mouseShow" @mouseover="mouseShow=true" v-if="!collectionStatus"></div> -->
      <img alt="收藏"
           width="40px"
           id="collecplan"
           src="~@/assets/img/scx.png"
           @click="collecplan()"
           v-show="!mouseShow"
           @mouseover="mouseShow=true"
           v-if="!collectionStatus" />
      <div style="width:40px;height:38px;"
           class="box-shadow quxiao"
           id="unCollecplan"
           @click="unCollecplan()"
           v-else></div>
      <img alt="收藏"
           width="40px"
           src="~@/assets/img/collecplan.png"
           @click="collecplan()"
           v-if="mouseShow"
           @mouseout="mouseShow=false">
      <div style="height:5px;"></div>
      <img src="~@/assets/img/zixun.png"
           width="40px"
           alt="已咨询"
           v-if="inquiryStatus">
      <div style="width:40px;height:38px;"
           id="inquiryButton"
           v-else
           class="nozixun"
           @click="beforeInquiry()"
           @mouseover="mouseZxShow=true"
           @mouseout="mouseZxShow=false">
        <!-- <img src="~@/assets/img/zixun.png" width="40px" id="inquiryButton" @click="beforeInquiry()"> -->
        <div class="zixuning"
             v-show="mouseZxShow">咨询服务</div>
      </div>
    </div>
    <!-- 面包蟹 -->
    <!--面包蟹-->
    <div class="container">
      <div class="integralBreadcrumb">
        <div class="integralBreadcrumb-item"
             @click="routerHandle('home')">首页</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle('serviceList')">专业服务</div>
        <div class="el-icon-arrow-right jt"
             v-if="$route.query.title"></div>
        <div class="integralBreadcrumb-item"
             v-if="$route.query.title"
             @click="routerHandle('serviceList',{title:$route.query.title})">{{$route.query.title}}</div>
        <div class="el-icon-arrow-right jt"
             v-if="$route.query.title1"></div>
        <div class="integralBreadcrumb-item"
             v-if="$route.query.title1"
             @click="routerHandle('serviceList',{title:$route.query.title,title1:$route.query.title1})">{{$route.query.title1}}</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item">{{$route.query.key}}</div>
      </div>
    </div>
    <!-- <div class="container" style="height: 40px; line-height: 40px; color: #999">
      <span class="font_link_fw"><router-link to="/shopping/home">首页</router-link></span> &nbsp;&nbsp;>&nbsp;&nbsp;
      <span v-if="$route.query.title" class="productHref">
        <router-link to="/serviceList">专业服务</router-link>&nbsp;&nbsp;>&nbsp;&nbsp;</span>
      <span v-if="$route.query.title"><router-link :to="'/serviceList?title='+$route.query.title">
        {{$route.query.title}}</router-link>&nbsp;&nbsp;>&nbsp;&nbsp;
      </span>
      <span  v-if="$route.query.title1"><router-link :to="'/serviceList?title='+$route.query.title+'&title1='+$route.query.title1">
        {{$route.query.title1}}</router-link>&nbsp;&nbsp;>&nbsp;&nbsp;
      </span>
      <span style="color:#1D65A8 ; cursor:pointer"><b>{{$route.query.key}}</b></span>
    </div> -->
    <!-- 页面头部服务咨询 -->
    <!-- 页面头部服务咨询，服务咨询按钮 -->
    <div class="butPosi">
      <div @click="collectionStatus?unCollecplan():collecplan()"
           class="zxbut"> {{collectionStatus? '取消收藏' : '收藏'}}</div>
      <div @click="beforeInquiry()"
           v-if="!inquiryStatus"
           class="zxbut"> 服务咨询</div>
    </div>
    <!-- <div class="container ">
      <el-button class="topQuiryButton" @click="beforeInquiry()" id="inquiryButton" v-if="!inquiryStatus">服务咨询</el-button>
    </div> -->
    <div class="container"
         style="background-color: #ffffff;">
      <div style="width:831px; margin:20px auto;color:#333; line-height:35px">
        <!-- <h3 style="text-align: center;padding: 20px;">{{headerTitle}}</h3> -->
        <!-- 内容 -->
        <div v-for="(item, index) of imgList"
             :key="index">
          <img :src="item.url"
               style="max-width:100%"
               :alt="headerTitle">
        </div>
      </div>
    </div>
    <!-- 引入内容部分 -->
    <!-- <div class="container content topMargin">
      <div style="width: 100%">
        <div class="divimg">
          <div v-for="(item, index) of imgList" :key="index">
            <img :src="item.url">
          </div>
        </div>
        <div style="width:100%;text-align:center">
        </div>
      </div>
    </div> -->
    <!-- 上传附件 -->
    <el-dialog title="服务咨询"
               :close-on-click-modal="false"
               :visible="visible"
               class="dialog"
               :show-close="false"
               v-if="visible">
      <el-form ref="dataForm"
               label-width="0px"
               @submit.native.prevent>
        <el-form-item label=""
                      prop="fileList">
          <el-upload multiple
                     id="upload"
                     class="upload-demo"
                     ref="upload"
                     :action="uploadUrl"
                     :headers="upLoadHeaders"
                     :limit="9"
                     :on-preview="handlePreview"
                     :accept="'.doc,.docx,.xls,.xlsx,.pdf'"
                     :data="{ fileSuffixType: 'file1' }"
                     :on-remove="removeFile"
                     :file-list="fileList"
                     :auto-upload="false"
                     :on-success="uploadSuccess"
                     :on-error="uploadError"
                     :on-exceed="exceed"
                     :before-upload="beforeUpload">
            <el-button slot="trigger"
                       size="small"
                       type="primary">咨询附件上传</el-button>
            <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button> -->
            <div slot="tip"
                 class="el-upload__tip">只能上传doc、docx、xls、xlsx或pdf文件</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="visible = false"
                   :loading="buttonLoading">取消</el-button>
        <el-button type="primary"
                   @click="inquiry()"
                   :loading="buttonLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { setStorage, getStorage } from '@/utils/storage'
import { getAccessToken } from '@/utils/userInfo'
// import { professionalServicesCollection, professionalServicesConsultation } from '@/utils/eventTracking'
export default {
  name: 'serviceContent',
  data () {
    return {
      imgSrc: '',
      collectionOrNot: '收藏',
      imgList: [],
      headerTitle: '',
      thumbnailUrl: '',
      serviceMenuList: [],
      timer: '',
      listShow: false,
      collectionStatus: false,
      inquiryStatus: false,
      mouseShow: false,
      mouseZxShow: false, // 咨询显示提示
      uploadUrl: window.SITE_CONFIG['apiURL'] + '/help/fileupload/sys/v2/upload',
      upLoadHeaders: {
        'Authorization': 'Bearer ' + getAccessToken()
      },
      visible: false,
      fileList: [],
      fileListLength: null,
      sysOssEntities: [],
      buttonLoading: false,
      uploadTimer: null,
      uploadFalse: false // 文件上传失败标志位
    }
  },
  computed: {},
  methods: {
    // 打开上传附件模态框
    beforeInquiry () {
      this.visible = true
    },
    // 咨询
    async inquiry () {
      // professionalServicesConsultation(this.$route.query.key)
      let _this = this
      if (getAccessToken()) {
        this.buttonLoading = true
        // 获取是否有待上传的文件
        let haveUploadFiles = document.getElementById('upload').getElementsByClassName('el-upload-list__item is-ready')
        // console.log(haveUploadFiles)
        if (haveUploadFiles.length > 0) {
          // 等待文件上传完成
          await this.uploadBeforeSubmit()
        }
        // 有文件上传失败，终止保存请求
        if (this.uploadFalse) {
          this.buttonLoading = false
          this.uploadFalse = false
          return false
        }
        let inquiryButton = document.getElementById('inquiryButton')
        inquiryButton.style.pointerEvents = 'none'
        inquiryButton.cursor = 'not-allowed'
        let params = {
          userId: '',
          inquryConsultationOssForms: this.sysOssEntities,
          serviceId: this.$route.query.id,
          consultationType: '10'
        }
        _this.$request.postParam(`/front/user/home/homeConsultationRecord/save`, params)
          .then((result, total, code, _data) => {
            this.inquiryStatus = true
            if (code === 0) {
              _this.$confirm('您已发起了该服务的咨询、请在服务咨询里查找。我们会及时与您联系！', '友情提示', {
                showCancelButton: false,
                confirmButtonText: '确定',
                type: 'success'
              })
            } else {
              _this.$confirm(_data.msg, '友情提示', {
                showCancelButton: false,
                confirmButtonText: '确定',
                type: 'error'
              })
            }
            inquiryButton.style.pointerEvents = ''
            inquiryButton.cursor = ''
            _this.buttonLoading = false
            _this.fileListLength = null
            _this.visible = false
            _this.uploadFalse = false
          })
          // eslint-disable-next-line handle-callback-err
          .catch(err => {
            inquiryButton.style.pointerEvents = ''
            inquiryButton.cursor = ''
            _this.buttonLoading = false
          })
      } else {
        this.$router.push({ name: 'login' })
      }
    },
    uploadBeforeSubmit () {
      let _this = this
      // 上传文件
      this.$refs.upload.submit()
      this.sysOssEntities = []
      return new Promise((resolve, reject) => {
        _this.uploadTimer = setInterval(_ => {
          if (_this.sysOssEntities.length === _this.fileListLength) {
            clearInterval(_this.uploadTimer)
            setTimeout(__ => {
              return resolve()
            }, 100)
          }
        }, 100)
      })
    },
    // 跳转
    routerHandle (routerName, query) {
      if (routerName) {
        this.$router.push({ name: routerName, query: query })
      }
    },
    uploadSuccess (response, file, fileList) {
      if (response.code < 0) {
        this.$message({
          message: response.message,
          type: 'error'
        })
        this.buttonLoading = false
        return false
      }
      this.fileListLength = fileList.length
      this.sysOssEntities.push({ sysOssId: response.data.aliOssId })
    },
    // eslint-disable-next-line handle-callback-err
    uploadError (err, file, fileList) {
      // console.log('response', err)
      // console.log('file', file)
      // console.log('fileList', fileList)
      this.$message({
        message: '文件上传失败！',
        type: 'error'
      })
      this.uploadFalse = true
      this.fileListLength = fileList.length
    },
    exceed () { },
    // 上传文件格式校验，过滤不合格文件
    beforeUpload (file) {
      let newName = file.name.slice(0, file.name.lastIndexOf('.'))
      let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
      if (regx.test(newName)) {
      } else {
        this.$message.warning('文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号')
        return false
      }
      if (file.type !== 'application/msword' && file.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && file.type !== 'application/vnd.ms-excel' && file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && file.type !== 'application/pdf') {
        this.$confirm('只能上传doc、docx、xls、xlsx或pdf文件，不符合要求的文件无法上传！', '友情提示', {
          showCancelButton: false,
          confirmButtonText: '确定',
          type: 'error'
        })
        this.buttonLoading = false
        this.uploadFalse = true
        // this.visible = false
        return false
      }
    },
    submitUpload () {
      // console.log(this.fileList)
      this.$refs.upload.submit()
    },
    removeFile (file, fileList) {
      // console.log(file, fileList)
      if (!file.id) { return false }
      this.$request.post(`/sys/oss/delete`, { 'ids': [file.id] })
        .then((data) => {
          // 从sysOssEntities中删除id
          for (let i = 0; i < this.sysOssEntities.length; i++) {
            if (this.sysOssEntities[i].aliOssId === file.id) {
              this.sysOssEntities.splice(i, 1)
              break
            }
          }
          this.$message({
            message: '删除成功！',
            type: 'success'
          })
        }).catch(() => {
        })
    },
    handlePreview (file) {
      // console.log(file)
    },
    // 服务收藏
    async collecplan () {
      // professionalServicesCollection(this.$route.query.key)
      let _this = this
      let params = {
        key: this.$route.query.key,
        planUrl: encodeURIComponent(window.location.href),
        planName: this.$route.query.key,
        title: this.$route.query.title,
        title1: this.$route.query.title1 || '',
        createTime: this.format(),
        collectorId: '',
        serviceId: this.$route.query.id,
        thumbnailUrl: this.thumbnailUrl,
        collectionType: '10'
      }
      // console.log(params)
      // 登录
      if (getAccessToken()) {
        let collecPlan = document.getElementById('collecplan')
        collecPlan.style.pointerEvents = 'none'
        collecPlan.cursor = 'not-allowed'
        // http 添加商品到收藏列表
        delete params.createTime
        delete params.thumbnailUrl
        _this.$request.postParam(`/front/user/home/homePlanCollection/collection`, params)
          .then((postParam) => {
            _this.$confirm('您已收藏了该服务、请在服务收藏里查找！', '友情提示', {
              showCancelButton: false,
              confirmButtonText: '确定',
              type: 'success'
            })
            collecPlan.style.pointerEvents = ''
            collecPlan.cursor = ''
            _this.getCollectionStatus()
          })
          // eslint-disable-next-line handle-callback-err
          .catch(err => { })
      } else {
        this.$router.push({ name: 'login' })
        /*
        // 未登录
        // sessionStorage.removeItem('v1serviceList')
        let serviceList = getStorage('serviceList')
        if (!serviceList) {
          serviceList = []
          setStorage('serviceList', serviceList)
        }
        serviceList.push(params)
        // 去重
        let result = []
        let obj = {}
        for (let i = 0; i < serviceList.length; i++) {
          // console.log(obj[serviceList[i].key])
          if (!obj[serviceList[i].serviceId]) {
            result.push(serviceList[i])
            obj[serviceList[i].serviceId] = true
          }
        }
        setStorage('serviceList', result)
        _this.$confirm('您已收藏了该服务、请在服务咨询里查找！', '友情提示', {
          showCancelButton: false,
          confirmButtonText: '确定',
          type: 'success'
        })
        // console.log(getStorage('serviceList'))
        _this.getCollectionStatus()
        */
      }
    },
    // 取消收藏
    unCollecplan () {
      if (getAccessToken()) {
        this.$request.postParam(`/front/user/home/homePlanCollection/cancelCollection`,
          {
            serviceId: this.$route.query.id,
            collectionType: '10'
          }
        ).then(_data => {
          this.$message({
            message: '取消收藏成功！',
            type: 'success'
          })
          this.getCollectionStatus()
        })
          // eslint-disable-next-line handle-callback-err
          .catch(err => {
          })
      } else {
        let serviceList = getStorage('serviceList')
        let ind = -1
        if (!serviceList) {
          serviceList = []
        }
        serviceList.forEach((item, index) => {
          if (item.serviceId.toString() === this.$route.query.id.toString()) {
            ind = index
          }
        })
        serviceList.splice(ind, 1)
        setStorage('serviceList', serviceList)
        this.$message({
          message: '取消收藏成功！',
          type: 'success'
        })
        this.getCollectionStatus()
      }
    },
    // 日期格式化
    format () {
      function addZero (data) {
        data = data.toString()
        if (data.length < 2) {
          return '0' + data
        } else {
          return data
        }
      }
      let time = new Date()
      let year = addZero(time.getFullYear())
      let month = addZero(time.getMonth())
      let day = addZero(time.getDay())
      let hours = addZero(time.getHours())
      let minutes = addZero(time.getMinutes())
      let second = addZero(time.getSeconds())
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + second
    },
    // 获取服务数据
    getDetail () {
      this.$request.get(`/front/user/home/homeService/info/${this.$route.query.id}`, {
        serviceId: this.$route.query.id
      })
        .then(data => {
          // if (data.code === 0) {
          this.headerTitle = data.name || ''
          this.thumbnailUrl = data.labelChartUrl || ''
          this.imgList = data.sysOssAliVos || []
          // } else {
          //   this.$message.error(data.msg || '获取失败')
          //   this.headerTitle = ''
          //   this.thumbnailUrl = ''
          //   this.imgList = []
          // }
          // this.headerTitle = (data && data.name) || ''
          // this.thumbnailUrl = (data && data.thumbnailUrl) || ''
          // this.imgList = (data && data.sysOssEntities) || []
        })
        // eslint-disable-next-line handle-callback-err
        .catch(err => {
          this.headerTitle = ''
          this.thumbnailUrl = ''
          this.imgList = []
        })
    },
    // 查询服务是否收藏
    getCollectionStatus () {
      if (getAccessToken()) {
        this.$request.postParam(`/front/user/home/homePlanCollection/queryCollectionFlag`,
          {
            serviceId: this.$route.query.id,
            collectionType: '10'
          }).then((result, total, page, data) => {
          if (result) {
            this.collectionStatus = true
          } else {
            this.collectionStatus = false
          }
        })
          // eslint-disable-next-line handle-callback-err
          .catch(err => { })
      } else {
        let serviceList = getStorage('serviceList')
        if (serviceList && serviceList.length > 0) {
          for (let i = 0; i < serviceList.length; i++) {
            if (serviceList[i].serviceId.toString() === this.$route.query.id.toString()) {
              this.collectionStatus = true
              break
            } else {
              this.collectionStatus = false
            }
          }
        } else {
          this.collectionStatus = false
        }
      }
    },
    // 查询服务是否咨询
    getZXStatus () {
      if (getAccessToken()) {
        this.$request.postParam(`/front/user/home/homeConsultationRecord/queryConsultationFlag`, {
          consultationType: '10',
          serviceId: this.$route.query.id
        })
          .then(data => {
            this.inquiryStatus = data
          })
          // eslint-disable-next-line handle-callback-err
          .catch(err => { })
      } else {
        let serviceList = getStorage('serviceList')
        if (serviceList && serviceList.length > 0) {
          for (let i = 0; i < serviceList.length; i++) {
            if (serviceList[i].serviceId.toString() === this.$route.query.id.toString()) {
              this.collectionStatus = true
              break
            } else {
              this.collectionStatus = false
            }
          }
        } else {
          this.collectionStatus = false
        }
      }
    },
    moveOut () {
      this.timer = setTimeout(_ => {
        this.listShow = false
      }, 1000)
    },
    moveOver () {
      clearInterval(this.timer)
    },
    // 跳转一级目录
    changeMenu (name) {
      this.$router.push({ name: 'planList', query: { title: name } })
    }
  },
  created () {
    this.getDetail()
    this.getZXStatus()
    this.getCollectionStatus()
    // 获取服务数据
    // this.$request.get(`/product/businessservice/findServiceTree`)
    //   .then(data => {
    //     // console.log(data.data)
    //     this.serviceMenuList = data.data
    //   })
  },
  beforeDestroy () {
    clearInterval(this.uploadTimer)
    clearInterval(this.timer)
  }
}
</script>

<style scoped>
.banner {
  background: url("~@/assets/img/bannerplan.jpg") no-repeat top center;
}

.content {
  font-size: 14px;
  line-height: 35px;
}

.topMargin {
  margin-top: 30px;
  min-height: 500px;
  margin-bottom: 30px;
}

.divimg {
  width: 100%;
  height: auto;
  padding: 5px;
}
.divimg img {
  width: 50%;
  border: 0px;
  /* float: left; */
}
@media (min-width: 720px) {
  .divimg {
    padding: 5px;
  }
  .divimg img {
    width: 100%;
    /*border: 3px;*/
    /* float: left; */
  }
}
.font_link_fw a {
  color: #666;
}
.font_link_fw a:hover {
  color: #666;
}
.inquiryButton {
  position: fixed;
  z-index: 11;
  right: 0px;
  top: 260px;
  cursor: pointer;
}
.menu_list {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 150px;
  /*height: 212px;*/
  z-index: 10;
  background-color: #f0f0f0;
  font-size: 14px;
  /*overflow: hidden;*/
  border-bottom: 2px #679dcc solid;
}
.menu_list:hover {
  cursor: pointer;
}
.productHref {
  cursor: pointer;
  color: #333;
}
.shoucang {
  background: url("~@/assets/img/collecplan.png") no-repeat top;
  background-size: 100px 100px;
}
.quxiao {
  background: url("~@/assets/img/sc.jpg") no-repeat top;
}
.nozixun {
  background: url("~@/assets/img/zxno.png") no-repeat center center;
  background-size: 20px 20px;
  padding-top: 38px;
}
.zixuning {
  background-color: #679dcc;
  width: 100%;
  height: 100px;
  padding: 2px 12px;
  text-align: center;
  line-height: 24px;
  font-size: 16px;
  color: #ffffff;
}
.topQuiryButton {
  margin-bottom: 20px;
  background-color: #1e64a9;
  color: #fff;
}
.butPosi {
  display: flex;
  position: fixed;
  bottom: 0;
  background-color: rgba(30, 100, 169, 0.2);
  width: 100%;
  /* margin: 0 auto; */
}
.zxbut {
  /* display: inline-block; */
  margin: 5px auto;
  padding: 5px 20px;
  /* width: 100px; */
  border: 1px solid #1e64a9;
  background-color: #fff;
  color: #1e64a9;
  cursor: pointer;
  border-radius: 5px;
}
.zxbut:hover {
  background-color: #1e64a9;
  color: #fff;
}
</style>
